"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 上传图片组件
 *
 * uploadParams: {
 *    resourceConfigFlag: 'sfe_store'
 * }
 *
 */
var _default2 = exports.default = {
  name: 'FormUploadImg',
  props: {
    fileUrl: {
      type: String,
      default: ''
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 接受数据类型
    accept: {
      type: String,
      default: 'image/*'
    },
    // 最大限制，单位MB（当前默认值为后端上传api最大接受值）
    maxSize: {
      type: Number,
      default: 50
    },
    // 上传额外携带的参数
    uploadParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 底部文字
    footerText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isLoading: false,
      /** preview */
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    }
  },
  methods: {
    handlePictureCardPreview: function handlePictureCardPreview() {
      this.dialogImageUrl = this.fileUrl;
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove() {
      console.log('remove');
      this.setUrl('');
    },
    setUrl: function setUrl(url) {
      console.log('更新pic', url);
      this.$emit('update:fileUrl', url);
    },
    // 上传
    uploadData: function uploadData(file, fileList) {
      var _this = this;
      // console.log(888)
      // 数据状态初始化
      this.confirmText = this.$t('common.confirm');
      var rawFile = file.raw;
      if (!rawFile) return;
      // 大小限制||压缩图片
      console.log('上传限制', this.maxSize, rawFile.size);
      if (this.maxSize && rawFile.size > this.maxSize * 1024 * 1024) {
        this.$message.error("".concat(this.$t('common.uploadLimitDesc1')).concat(this.maxSize).concat(this.$t('common.uploadLimitDesc2')));
        return;
      }
      this.isLoading = true;
      var param = new FormData();
      param.append('file', rawFile);
      // 额外参数
      Object.keys(this.uploadParams).forEach(function (key) {
        param.append(key, _this.uploadParams[key]);
      });
      this.$api.common.uploadFile(param).then(function (res) {
        // console.log(999, res)
        var data = res.data || {};
        _this.setUrl(data.url || '');
      }).finally(function () {
        _this.isLoading = false;
      });
    }
  }
};